import type { PublicRuntimeConfig } from "@/lib/config/publicRuntimeConfig";

let publicRuntimeConfig: PublicRuntimeConfig | null = null;

export const setPublicRuntimeConfigInstance = (
  config: PublicRuntimeConfig,
): void => {
  publicRuntimeConfig = config;
};

export const getPublicRuntimeConfig = (): PublicRuntimeConfig => {
  if (publicRuntimeConfig === null) {
    throw new Error(
      "Public runtime config is not initialized yet. Ensure createAppStore ran before shell bootstrap.",
    );
  }
  return publicRuntimeConfig;
};
